<template>
    <form-row title="Notes" :label_align_top="true">
        <div class="w-full">
            <input-textarea
                name="roads_notes"
                v-model="commercial.roads_notes"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
